import 'core-js/proposals/reflect-metadata';
import { Serializable, jsonProperty } from 'ts-serializable';
import Category from '../careLine/Category';
import Exam from '../careLine/Exam';
import Procedure from '../careLine/Procedure';
import VitalSign from '../careLine/VitalSign';


class OccupationalHealth extends Serializable {

    @jsonProperty(String, null)
    id: string = '';

    @jsonProperty(String, null)
    empresaId: string = '';

    @jsonProperty(String, null)
    nome: string = '';

    @jsonProperty(Boolean)
    inativo: boolean = false;

    @jsonProperty([Category])
    categorias: Category[] = []

    @jsonProperty([Exam])
    exames: Exam[] = []

    @jsonProperty([Procedure])
    procedimentos: Procedure[] = []
    
    @jsonProperty([VitalSign])
    sinaisVitais: VitalSign[] = []
}

export default OccupationalHealth;